import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
    StyledHeading,
    StyledTicketHeader,
    StyledTicketCount,
    StyledButtonGroup,
    StyledWorkgroupList,
    StyledWorkgroupListItem,
    StyledClaimNewTicketButton,
} from '../constants/ticketlist.styled';
import GIButton from '../../../../components/common/button/GIButton';
import { ITicketHeaderProps } from '../constants/ticketlist.interface';
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';
import { Popover, PopoverBody, PopoverTrigger } from '../../../../components/common/popover/Popover';

export const TicketHeader: React.FC<ITicketHeaderProps> = props => {
    const {
        fetchDefaultTickets,
        ticketsCount,
        onClaimNewTicket,
        onAddNewTicket,
        workgroupOptions,
        enableTicketSupport,
        viewTicketPermission,
    } = props;
    const intl = useIntl();
    return (
        <StyledTicketHeader>
            <StyledHeading data-testid="manage-tickets-header">
                <FormattedMessage id="ticketList.title.tickets" />
                <StyledTicketCount>
                    <FormattedMessage id="ticketList.title.ticketsCount" values={{ count: ticketsCount }} />
                </StyledTicketCount>
            </StyledHeading>
            <StyledButtonGroup>
                <GIButton
                    id="openAndAssignedToMe"
                    labelId="ticketList.btn.openAndAssignedToMe"
                    onClickHandler={fetchDefaultTickets}
                    isDisabled={false}
                />
                <StyledClaimNewTicketButton>
                    <GIButton
                        id="claimNewTicket"
                        labelId="ticketList.btn.claimNewTicket"
                        onClickHandler={() => onClaimNewTicket()}
                        isDisabled={false}
                    />
                </StyledClaimNewTicketButton>
                <Popover>
                    <PopoverTrigger>
                        <GIButton
                            id="claimNewTicketButton"
                            labelId=""
                            ariaLabel={intl.formatMessage({ id: 'ticketList.btn.claimNewTicket' })}
                            icon={<FontAwesomeIcon icon={faChevronDown} />}
                            isDisabled={false}
                        />
                    </PopoverTrigger>

                    <PopoverBody>
                        <StyledWorkgroupList>
                            {workgroupOptions.map((queue: any) => (
                                <StyledWorkgroupListItem
                                    key={queue.value}
                                    onClick={() => onClaimNewTicket(queue.value)}
                                >
                                    {queue.text}
                                </StyledWorkgroupListItem>
                            ))}
                        </StyledWorkgroupList>
                    </PopoverBody>
                </Popover>

                <ConditionalRendering isTrue={enableTicketSupport && viewTicketPermission}>
                    <GIButton
                        id="addNewTicket"
                        labelId="ticketList.btn.addNewTicket"
                        onClickHandler={onAddNewTicket}
                        isDisabled={false}
                    />
                </ConditionalRendering>
            </StyledButtonGroup>
        </StyledTicketHeader>
    );
};
